module.exports = __webpack_public_path__ + "static/img/for-control.33adf280.jpg";